import Model from "./base/model";

class Settings extends Model {
  resourceName() {
    return "settings";
  }

  fields() {
    return {
      permissions:"",
      role:"",
      plans:"",
      features:"",
    };
  }
}



export default new Settings();
